import { magentoApi } from "./magentoApi";

export async function login(redirectUrl) {
  let result = await magentoApi.post("canon/spa/sso", {
    key: "STS WSO AU",
    secret: "secret for this single page app",
    redirectUrl
  });

  // The response can be double encoded by the backend to bypass the undesired behavior of Magento on data object or array.
  if (typeof result === "string") {
    result = JSON.parse(result);
  }

  if (result.next === "redirect") {
    return { redirect: result.load };
  } else if (result.next === "store-token") {
    return {
      token: result.load.token,
      expireAt: result.load.expireAt
    };
  }
}
